import "./PlannedPublishingPage.css";
import React, { useState } from "react";

import AcornPlanningPublishingTab from "./AcornPlanningPublishingTab/AcornPlanningPublishingTab";
import PublishingProcessTab from "./PublishingProcessTab/PublishingProcessTab";
import MarketingTab from "./MarketingTab/MarketingTab";
import CostTab from "./CostTab/CostTab";

import GetStartedHero from "../GetStarted/GetStartedHero";
import ProcessStepSelector from "../Shared/ProcessStepSelector/ProcessStepSelector";
import Footer from "../../Footer";

function PlannedPublishingPage({}) {
  const stepsData = [
    {
      label: "에이콘 기획 출판",
      Component: AcornPlanningPublishingTab,
    },
    {
      label: "출판 과정",
      Component: PublishingProcessTab,
    },
    {
      label: "마케팅",
      Component: MarketingTab,
    },
    {
      label: "비용",
      Component: CostTab,
    },
  ];

  return (
    <div className="planned-publishing-page">
      <GetStartedHero title={"기획 출판"} />
      <div className="planned-publishing-page-tabs">
        <ProcessStepSelector stepsData={stepsData} />
      </div>
      <Footer />
    </div>
  );
}

export default PlannedPublishingPage;
